/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_OverlineInputs */

const en_mk_calc_overline = /** @type {(inputs: Mk_Calc_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do the maths`)
};

const id_mk_calc_overline = /** @type {(inputs: Mk_Calc_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitung sendiri`)
};

/**
* | output |
* | --- |
* | "Do the maths" |
*
* @param {Mk_Calc_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_overline = /** @type {((inputs?: Mk_Calc_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_overline(inputs)
	return en_mk_calc_overline(inputs)
});